import React from 'react';
import PropTypes from "prop-types";

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const LoadEarlierBar = (props) => {

    return (
        <tbody className="timeline-bar earlier">
            <tr>
                <td colSpan="7">
                    <button
                        type="button"
                        className="timeline-bar-button"
                        onClick={(e) => props.onClick(e)}
                        disabled={props.disabled}
                    >
                        <i className="fa fa-chevron-up"/>&nbsp;
                        Earlier Bookings
                    </button>
                </td>
            </tr>
        </tbody>
    );
}

LoadEarlierBar.propTypes = {
    onClick: PropTypes.func.isRequired,
    disabled: PropTypes.any,
}

LoadEarlierBar.defaultProps = {
    disabled: false
}

export default LoadEarlierBar;
